export function normalizeLocationForUrl(text) {
  if (!text) return '';
  
  // Convert to lowercase and trim
  let normalized = text.toLowerCase().trim();
  
  // Normalize Unicode characters (decompose accented characters)
  normalized = normalized.normalize('NFD');
  
  // Remove diacritics/accents
  normalized = normalized.replace(/[\u0300-\u036f]/g, '');
  
  // Replace specific accented characters (fallback for browsers without normalize)
  normalized = normalized
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõöø]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ñ]/g, 'n')
    .replace(/[çć]/g, 'c')
    .replace(/[ß]/g, 'ss')
    .replace(/[æ]/g, 'ae')
    .replace(/[œ]/g, 'oe')
    .replace(/[þ]/g, 'th')
    .replace(/[ð]/g, 'd');
  
  // Replace special characters with nothing
  normalized = normalized.replace(/[^\w\s-]/g, '');
  
  // Replace spaces and underscores with hyphens
  normalized = normalized.replace(/[\s_]+/g, '-');
  
  // Remove duplicate hyphens
  normalized = normalized.replace(/-+/g, '-');
  
  // Remove leading and trailing hyphens
  normalized = normalized.replace(/^-+|-+$/g, '');
  
  return normalized;
}